import React from 'react';

export interface LoadingProps {
    text?: string;
}

const Loading: React.FC<LoadingProps> = ({ text }) => {
    return (
        <div className="min-h-screen flex flex-col space-y-12 items-center justify-center bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
		<div className="w-16 h-16 bg-blue-500 dark:bg-blue-400
		rounded-full animate-ping"></div>
		<p className="text-gray-700 dark:text-gray-300">{text}</p>
	</div>
    );
};

export default Loading;